import { Box, Theme, Button, Stack, Pagination } from '@mui/material';
import { useHistory, useLocation } from 'react-router';
import { useEffect, useState } from 'react';
import { SxProps } from '@mui/system';
import { ColumnType, DataTable } from '../../../DataTable';
import { LoadingDialog } from '../../../commonComponents';
import { SubHeading } from '../../../investors/components';
import { ApplicationNctProps, AuditLogsType } from '../../../../redux-store/types/nct';
import { formatShortDateAndTime } from '../../../../utils/date';

const getTableHeader = (): ColumnType[] => {
  return [
    {
      header: 'S.No.',
      valueGetter: (row: AuditLogsType, index: number) => Number(index) + 1,
    },
    {
      header: 'Investor Name',
      valueGetter: ({ name = '' }: AuditLogsType) => name || '-',
    },
    {
      header: 'Mobile Number',
      valueGetter: ({ phone = '' }: AuditLogsType) => phone || '-',
    },
    {
      header: 'Email ID',
      valueGetter: ({ email = '' }: AuditLogsType) => email || '-',
    },
    {
      header: 'Modified By',
      valueGetter: ({ modified_by = '' }: AuditLogsType) => modified_by || '-',
    },
    {
      header: 'Modified Date',
      valueGetter: ({ updatedAt = '' }: AuditLogsType) => formatShortDateAndTime(updatedAt) || '-',
    },
  ];
};

export default function UpdatedLogs({
  isLoading,
  application,
  boxStyles,
}: {
  isLoading?: boolean;
  application: ApplicationNctProps;
  boxStyles?: SxProps<Theme>;
  DashboardApplicationsList?: boolean;
}): JSX.Element {
  const history = useHistory();
  const location = useLocation();

  const [applicationsListData, setApplicationsListData] = useState<AuditLogsType[]>();

  const [page, setPage] = useState(0);
  const rowsPerPage = 5;

  // Slice data for current page
  const paginatedData = applicationsListData?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  // Pagination handlers
  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage - 1);
  };

  useEffect(() => {
    setApplicationsListData(application?.audit_logs ? [...application.audit_logs] : []);
  }, [application]);

  const additionalCell = {
    header: '',
    renderEditDeleteCell: (row: AuditLogsType): JSX.Element => {
      const [loadingPopup, setLoadingPopup] = useState(false);

      const handleLoadingPopupClose = () => {
        setLoadingPopup(false);
      };
      return (
        <Box display={'flex'} justifyContent={'center'}>
          <Button
            variant="text"
            sx={{ color: 'primary.main', fontSize: 12, '&:hover': { background: 'transparent' } }}
            onClick={() =>
              history.push(`/updated-details/${row?.applicationId}`, {
                id: row?.applicationId,
                source: location?.pathname,
                auditId: row?.id,
                section: 'updated-logs-section',
              })
            }>
            View Details
          </Button>

          <LoadingDialog
            loadingPopup={loadingPopup}
            onLoadingPopupClose={handleLoadingPopupClose}
            loaderText={'Downloading'}
          />
        </Box>
      );
    },
  };

  return (
    <>
      <SubHeading>Update Details</SubHeading>
      <DataTable
        isLoading={isLoading}
        tableHeader={[...getTableHeader(), additionalCell]}
        tableData={paginatedData}
        rowCustomStyles={{
          '&:last-child td, &:last-child th': { border: 0 },
          '.MuiTableCell-body ': { color: '#686e72' },
          background: 'transparent',
        }}
        boxStyles={{ ...boxStyles, minHeight: 'fit-content' }}
      />
      <Stack direction="row" justifyContent="center" sx={{ mt: 5 }}>
        <Pagination
          count={Math.ceil((applicationsListData as AuditLogsType[])?.length / rowsPerPage)}
          page={page + 1} // Pagination's `page` is 1-based
          color="primary"
          onChange={handleChangePage}
        />
      </Stack>
    </>
  );
}
